<template>
  <div>


    <h3 class="mb-0 w-full block">
      <button
          :id="id + '-header'"
          class="flex justify-between items-center font-light text-xl w-full py-4 text-left ml-0 lowercase"
          :aria-controls="id + '-panel'"
          @click="this.toggle">

        {{ title }}
        <span class="fill-current flex-shrink-0 ml-2">
          <span :class="{'hidden': this.isExpanded, 'block': ! this.isExpanded}">+</span>
          <span :class="{'block': this.isExpanded, 'hidden': ! this.isExpanded}">-</span>
        </span>

      </button>
    </h3>
    <transition
        name="fade-height"
        v-on:before-enter="beforeEnter" v-on:enter="enter"
        v-on:before-leave="beforeLeave" v-on:leave="leave"
    >
      <section
          class="overflow-hidden transition ease-in-out"
          :id="id + '-panel'"
          v-show="this.isExpanded"
          :aria-labelledby="id + '-header'">
        <div class="pt-6 pb-12 text">
          <slot></slot>
        </div>
      </section>
    </transition>
  </div>
</template>
<script>
export default {
  name: "AccordionItem",
  props: {
    id: {
      type: String
    },
    title: {
      type: String,
      required: true
    },
  },
  data() {
    return {
      isExpanded: false
    }
  },
  methods: {
    toggle() {
      this.isExpanded = !this.isExpanded;
    },
    beforeEnter: function (el) {
      el.style.height = '0';
    },
    enter: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    beforeLeave: function (el) {
      el.style.height = el.scrollHeight + 'px';
    },
    leave: function (el) {
      el.style.height = '0';
    }
  }
};
</script>

<style>

.fade-height-enter-active,
.fade-height-leave-active {
  transition: all 0.4s ease-in-out;
}

.fade-height-enter-from,
.fade-height-leave-to {

}

</style>
